import React, { useMemo } from 'react';

import useDisabledUsers from 'hooks/useDisabledUsers';
import { getObjectiveLocale } from 'utils/HelperUtils';
import { getLeader } from 'utils/TeamHelper';

import InlineDialogSelectUser from 'components/inline-dialog/InlineDialogSelectUser';
import { getNewInvolvements } from 'components/sidebar/sidebar-create/SidebarCreateHelper';

const Reviewer = ({
  objectiveValue,
  setObjectiveValue,
  updateTeam,
  ableToUpdate = false
}) => {
  const { involvements } = objectiveValue || {};

  const currentInvolvements = useMemo(() => {
    return [...involvements];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { checkIsUserDisabled } = useDisabledUsers({
    isEdit: true,
    isTeam: true,
    objective: objectiveValue
  });

  const selectedReviewer = involvements?.filter(
    ({ role }) => role === 'assigner'
  );
  const selectedOwner = getLeader(involvements);

  const handleChangeDialog = (involvements, type) => {
    const lastIndex = involvements?.length - 1;
    const selectedUser = involvements[lastIndex];

    checkIsUserDisabled(selectedUser?.user?.id, () => {
      let newInvolvements = getNewInvolvements(
        involvements,
        type,
        false,
        objectiveValue,
        null
      );

      setObjectiveValue((draft) => {
        draft.involvements = newInvolvements;
      });
    });
  };

  const updateReviewer = async () => {
    const newInvolvements = objectiveValue.involvements.map((involvement) => ({
      userId: involvement.user.id,
      role: involvement.role,
      ...(involvement?.extendedRole && {
        extendedRole: involvement?.extendedRole
      })
    }));

    const { isSuccess } = await updateTeam({ involvements: newInvolvements });
    if (!isSuccess) {
      setObjectiveValue((draft) => {
        draft.involvements = currentInvolvements;
      });
    }
  };

  return (
    <div className="w-1/2" data-cy="reviewer-team">
      <p className="typography-h100 text-n-800">
        {getObjectiveLocale('Reviewer Team')}
      </p>
      <div className="ml-[-8px]">
        <InlineDialogSelectUser
          objectiveValue={objectiveValue}
          selectedValue={selectedReviewer}
          handleChange={handleChangeDialog}
          permission={ableToUpdate}
          selectedOwner={selectedOwner ? [selectedOwner] : []}
          type="assigner"
          customPlaceholder={true}
          isRemoveable={false}
          position="right"
          header="Reviewer Team"
          onCloseDialog={updateReviewer}
          dataCy="reviewer-team-button"
        />
      </div>
    </div>
  );
};

export default Reviewer;
